module.exports = __webpack_public_path__ + "static/rss-934383908a9097f1f0ec586b50054aab.png";